<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <base-material-card
      color="light-blue"
      icon="mdi-account-tie"
      title="Documentos"
      class="px-5 py-3"
    >
      <v-data-table
        v-if="documentoslist"
        :headers="headers"
        :items="documentos"
        :search="search"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            />
            <v-spacer />
            <v-btn
              color="primary"
              fab
              dark
              small
              class="mb-2"
              @click="addDocuments()"
            >
              <v-icon
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.categoriaName }}</td>
            <td>
              <v-icon
                small
                class="mr-2"
                color="info"
                @click="downloadFile(item)"
              >
                mdi-download
              </v-icon>
              <v-icon
                small
                class="mr-2"
                color="success"
                @click="editItem(item)"
              >
                mdi-pencil-outline
              </v-icon>
              <v-icon
                small
                color="error"
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <addDocumentos
        :edited-item="datos"
        :edited-index="editedIndex"
      />
    </base-material-card>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import addDocumentos from './addDocumentos.vue'
  export default {
    name: 'DocumentosTable',
    components: {
      addDocumentos,
    },
    data: vm => {
      return {
        search: '',
        snackbar: false,
        colorSnak: 'info',
        text: '',
        timeout: 3000,
        datos: {},
        editedIndex: -1,
        headers: [
          {
            text: 'Nombre',
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Categoría',
            align: 'left',
            sortable: true,
            value: 'categoriaName',
          },
          {
            text: 'Acciones',
            value: 'acciones',
            sortable: false,
          },
        ],
        emailRules: [
          v => !!v || 'EL correo electrónico es requerido',
          v => /.+@.+\..+/.test(v) || 'Ingresa un correo valido',
        ],
      }
    },
    computed: {
      documentoslist: {
        get () {
          return this.$store.state.documentos.documentoslist
        },
      },
      documentos: {
        get () {
          return this.$store.state.documentos.documentosListado
        },
        set (value) {
          return this.$store.commit('documentos/setDocumentos', value)
        },
      },
      loading: {
        get () {
          return this.$store.state.documentos.loading
        },
      },
    },
    mounted () {
      this.$store.dispatch('documentos/getDocumentos')
    },
    methods: {
      addDocuments () {
        this.datos = {}
        this.editedIndex = -1
        this.$store.commit('documentos/setRegister', true)
      },
      async downloadFile (item) {
        var response = await this.$store.dispatch('documentos/downloadDocument', item.id)
        var nombre = await this.$store.dispatch('documentos/getNombreDocument', item.id)

        this.forceFileDownload(response, nombre)
      },
      forceFileDownload (response, nombre) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', nombre)
        document.body.appendChild(link)
        link.click()
      },
      editItem (item) {
        this.editedIndex = this.documentos.indexOf(item)
        item.file = null
        this.datos = Object.assign({}, item)
        this.$store.commit('documentos/setRegister', true)
      },
      deleteItem (item) {
        this.$confirm('Está seguro que desea eliminar el registro?', {
          buttonTrueText: 'Si',
          buttonFalseText: 'No',
        })
          .then(res => {
            if (res) {
              this.$store.dispatch('documentos/deleteDocumento', item.id)
                .then((response) => {
                  Vue.notify({
                    group: 'loggedIn',
                    text: response.data.success,
                    type: 'teal accent-3',
                    duration: 5000,
                  })
                })
                .catch(err => {
                  // eslint-disable-next-line
                  console.log(err)
                  Vue.notify({
                    group: 'loggedIn',
                    text: 'No se pudo eliminar en este momento',
                    type: 'red accent-2',
                    duration: 5000,
                  })
                },
                )
            }
          })
      },
    },

  }
</script>

<style scoped>
.v-card {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
